import { render, staticRenderFns } from "./ResetPswAction.vue?vue&type=template&id=a5205720&"
import script from "./ResetPswAction.vue?vue&type=script&lang=js&"
export * from "./ResetPswAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports